import React, { Component } from 'react';
import { connect } from 'react-redux';
import InputRange from 'react-input-range';
import Select from 'react-select';
import { updateFilters } from '../search/actions';
import { MAGIC_NUMBER, priceSelectOption } from '../../constants/magicNumbers';
import 'react-input-range/lib/css/index.css';
import { getNumberWithCommas } from '../../constants/util';

const mapStateToProps = (state) => ({
  search: state.Search
});

class PriceRangeSelect extends Component {
  constructor(props) {
    super(props);

    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.handlePriceFilterChange = this.handlePriceFilterChange.bind(this);
  }
  onSelectionChange = (range) => {
    const { dispatch } = this.props;
    const { filters } = this.props.search;
    const maxPrice = range.max === MAGIC_NUMBER.FIFTEENHUNDRED ? MAGIC_NUMBER.MAX_PRICE : range.max
    const newFilters = {
      ...filters,
      price: {
        min: Math.max(range.min, MAGIC_NUMBER.MIN_PRICE),
        max: Math.min(maxPrice, MAGIC_NUMBER.MAX_PRICE)
      }
    };
    dispatch(updateFilters(newFilters));
  };

  // this funtion is used to dispatch price from select box 
  handlePriceFilterChange = (selected) => {
    const { dispatch } = this.props;
    const { filters } = this.props.search;
    const [min, max] = selected.value.split("-");
    const newFilters = {
      ...filters,
      price: {
        min: parseInt(min),
        max: parseInt(max)
      }
    };

    dispatch(updateFilters(newFilters));
  };



  render() {
    const { price } = this.props.search.filters;
    const { i } = this.props.search;
    const value = `${price.min}-${price.max}`;
    const maxLabel = price.max >= MAGIC_NUMBER.FIFTEENHUNDRED ? `${MAGIC_NUMBER.FIFTEENHUNDRED.toLocaleString()}+` : `${price.max.toLocaleString()}`
    const label = `$${price.min.toLocaleString()} - $${maxLabel}`;
    const result = { value, label };
    return (
      <div id="price-range">
        {!!i && !!i.avg ? <div className="average-price">The average price is ${getNumberWithCommas(Math.round(i.avg))}</div> : null}
        <InputRange
          formatLabel={(value) => `$${getNumberWithCommas(value)}`}
          maxValue={MAGIC_NUMBER.FIFTEENHUNDRED}
          minValue={MAGIC_NUMBER.MIN_PRICE}
          value={price}
          step={price.max >= MAGIC_NUMBER.FIVEHUNDRED ? MAGIC_NUMBER.HUNDRED : MAGIC_NUMBER.TEN}
          onChange={this.onSelectionChange}
        />
        <span className="amt-plus">+</span>
        <div className="box-range">
          <div className="box-bg">
            <span className="price-rang-txt">Price per night</span>
            <Select
              className="price-range-select-box"
              classNamePrefix="price-range-select"
              value={result}
              onChange={this.handlePriceFilterChange}
              options={priceSelectOption}
              isSearchable={false}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(PriceRangeSelect);
